import { TabBar } from '@bp/ui-components';
import { useTranslation } from 'react-i18next';
import { Page } from '../../../components/Page/Page';
import { SettingsPersonsTable } from '../../../components/Persons/Tables/SettingsPersonsTable';
import { usePermissionChecker } from '../../../hooks/usePermissionChecker';
import { PersonRole } from '../../../types/planung-graphql-client-defs';

export const SetupPersons = () => {
  const { t } = useTranslation();
  const permissions = usePermissionChecker();

  return (
    <Page isForbidden={!permissions?.canManageSettings()}>
      <TabBar
        variant={'large'}
        tabs={[
          {
            trigger: t('persons.title', { count: 2 }),
            id: 'teachers',
            content: <SettingsPersonsTable personsRole={PersonRole.Teacher} />,
          },
          {
            trigger: t('persons.other'),
            id: 'other',
            content: <SettingsPersonsTable personsRole={PersonRole.Other} />,
          },
        ]}
      />
    </Page>
  );
};
